import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";

@Injectable({ providedIn: "root" })
export class EInvoiceEmailPrintableQueueHistoryService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "email-printable-queue-histories/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "email-printable-queue-histories/backoffice-ep";
    this.httpClient = http;
  }

  getAll(visa: ApiVisa): Observable<any> {
    let url: string;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<any>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getAllPromise(visa: ApiVisa): Promise<any> {
    let url: string;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<any>(
      url,
      this.getHttpHeader(visa)
    ).toPromise();
  }
 
  getDashboard(visa: ApiVisa, criteria: any): Observable<any> {
    let url: string;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "email-printable-queue-histories/dashboard/backoffice-ep";
    }
    return this.httpClient.post<any>(
      url,
      criteria,
      this.getHttpHeader(visa)
    );
  }

  getDashboardPromise(visa: ApiVisa, criteria: any): Promise<any> {
    let url: string;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "email-printable-queue-histories/dashboard/backoffice-ep";
    }
    return this.httpClient.post<any>(
      url,
      criteria,
      this.getHttpHeader(visa)
    ).toPromise();
  }
}
